module.exports = __webpack_public_path__ + "img/24-6.159160c0.png";